import Proj1 from "../assets/Proj1.png";
import Projjj2 from "../assets/Projjj2.png";
import proj3 from "../assets/proj3.png";
import proj4 from "../assets/proj4.png";
import proj5 from "../assets/proj5.png";
import proj6 from "../assets/proj6.png";
import Projnew from "../assets/Projnew.png";
import projnew2 from "../assets/projnew2.png";

export const ProjectList = [
  {
    name: "Restaurant Website",
    image: Proj1,
    github: "https://github.com/siwanijaiswal/Restaurant-Website",
    liveLink: ""
  },

  {
    name: "NewsPortal WebApp",
    image: Projnew,
    github: "https://github.com/siwanijaiswal/NewsAPI-Reactjs",
    liveLink: ""
  },
  {
    name: "TextAnalyzer WebApp",
    image: Projjj2,
    github: "https://github.com/siwanijaiswal/TextAnalyzer-ReactApp",
    liveLink: "https://text-utils-siwani.netlify.app/"
  },
  {
    name: "MyCloth Website",
    image: proj3,
    github: "https://github.com/siwanijaiswal/My-cloth-website",
    liveLink: "https://my-clothwebsite.netlify.app/"
  },
  {
    name: "Instagram Clone",
    image: proj4,
    github: "https://github.com/siwanijaiswal/Instagram-Clone",
    liveLink: "https://instagramclone12345.netlify.app/"
  },
  {
    name: "Todo-List Webapp",
    image: proj5,
    github: "https://github.com/siwanijaiswal/Todo-list",
    liveLink: "https://todo-list-sw.surge.sh/"
  },
  {
    name: "Enrollment Form",
    image: proj6,
    github: "https://github.com/siwanijaiswal/LGMVIP-Web/tree/master/Enrollment%20%20Form",
    liveLink: "https://enrollment-form12.netlify.app/"
  },
  {
    name: "Calculator",
    image: projnew2,
    github: "https://github.com/siwanijaiswal/LGMVIP-Web/tree/master/calculator",
    liveLink: "https://calc-sw.surge.sh/"
  },
];
